import { postEvent } from '../public'

export * from '../public/reducers/actions'
export * from './actionsSystem'

//API.Controllers
export const doLogin = ({ userName, password, ...rest } = {}) => {
	return postEvent({
		event: 'Login',
		data: { userName, password },
		...rest
	})
}

export const doAutoLogin = ({ ...rest } = {}) => {
	return postEvent({
		event: 'AutoLogin',
		data: {},
		...rest
	})
}

export const doGetLoginInfo = ({ ...rest } = {}) => {
	return postEvent({
		event: 'GetLoginInfo',
		data: {},
		...rest
	})
}

export const doLogout = ({ ...rest } = {}) => {
	return postEvent({
		event: 'Logout',
		data: {},
		...rest
	})
}

export const doForgetPassword = ({ userName, resetEmail, ...rest } = {}) => {
	return postEvent({
		event: 'ForgetPassword',
		data: { userName, resetEmail },
		...rest
	})
}

export const doCheckToken = ({ token, ...rest } = {}) => {
	return postEvent({
		event: 'CheckToken',
		data: { token },
		...rest
	})
}

export const doSetPassword = ({ token, password, ...rest } = {}) => {
	return postEvent({
		event: 'SetPassword',
		data: { token, password },
		...rest
	})
}

export const doChangePassword = ({ oldPassword, newPassword, ...rest } = {}) => {
	return postEvent({
		event: 'ChangePassword',
		data: { oldPassword, newPassword },
		...rest
	})
}

export const doChangePasswordUnLogin = ({ oldPassword, newPassword, userName, ...rest } = {}) => {
	return postEvent({
		event: 'ChangePasswordUnLogin',
		data: { oldPassword, newPassword, userName },
		...rest
	})
}

export const doGetPersonByRoleName = ({ roleName, ...rest } = {}) => {
	return postEvent({
		event: 'GetPersonByRoleName',
		data: { roleName },
		...rest
	})
}

//文件目录
export const doGetQualityFileCatalog = ({ id, fatherID, ...rest } = {}) => {
	return postEvent({
		event: 'GetQualityFileCatalog',
		data: { id, fatherID },
		...rest
	})
}
export const doSaveQualityFileCatalog = ({ id, fatherID, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveQualityFileCatalog',
		data: { id, fatherID, changedValues基本信息 },
		...rest
	})
}
export const doDeleteQualityFileCatalog = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'DeleteQualityFileCatalog',
		data: { id },
		...rest
	})
}

//文件管理
export const doGetQualityFile = ({ id, fatherID, ...rest } = {}) => {
	return postEvent({
		event: 'GetQualityFile',
		data: { id, fatherID },
		...rest
	})
}
export const doSaveQualityFile = ({ id, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveQualityFile',
		data: { id, changedValues基本信息 },
		...rest
	})
}
export const doDeleteQualityFile = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'DeleteQualityFile',
		data: { id },
		...rest
	})
}

// 系统节假日管理
export const doGetSysHoliday = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'GetSysHoliday',
		data: { id },
		...rest
	})
}
export const doSaveSysHoliday = ({ id, changedValues基本信息, ...rest } = {}) => {
	return postEvent({
		event: 'SaveSysHoliday',
		data: { id, changedValues基本信息, },
		...rest
	})
}
export const doDeleteSysHoliday = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'DeleteSysHoliday',
		data: { id },
		...rest
	})
}






//PostLims => Web-CommController
export const doGetCodeInfo = ({ code, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetCodeInfo',
			isWXEvent: true,
			data: { code },
		},
		...rest
	})
}

export const doLoginLims = ({ code, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'Login',
			data: { code },
		},
		...rest
	})
}

export const doGetJSSDKSignatureInfo = ({ url, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetJSSDKSignatureInfo',
			isWXEvent: true,
			data: { url },
		},
		...rest
	})
}

export const doGetContractList = ({ row, query, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetContractList',
			data: { row, query },
		},
		...rest
	})
}

export const doGetContract = ({ contractID, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetContract',
			data: { contractID },
		},
		...rest
	})
}

export const doGetReportList = ({ row, query, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetReportList',
			data: { row, query },
		},
		...rest
	})
}

export const doGetReportReviewList = ({ row, query, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetReportReviewList',
			data: { row, query },
		},
		...rest
	})
}

export const doGetReportApprovalList = ({ row, query, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetReportApprovalList',
			data: { row, query },
		},
		...rest
	})
}

export const doGetReport = ({ reportID, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetReport',
			data: { reportID },
		},
		...rest
	})
}

export const doGetReportApprovalTime = ({ reportID, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetReportApprovalTime',
			data: { reportID },
		},
		...rest
	})
}

export const doSubmitReport = ({ reportID, action, comment, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'SubmitReport',
			data: { reportID, action, comment },
		},
		...rest,
	})
}

export const doSubmitReportApprovalTime = ({ reportID, action, comment, changeValues, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'SubmitReportApprovalTime',
			data: { reportID, action, comment, changeValues },
		},
		...rest,
	})
}

export const doDecryptBarCode = ({ barCode, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'DecryptBarCode',
			data: { barCode },
		},
		...rest,
	})
}

export const doGetPlanStartList = ({ row, query, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetPlanStartList',
			data: { row, query },
		},
		...rest,
	})
}

export const doGetPlan = ({ contractID, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetPlan',
			data: { contractID },
		},
		...rest
	})
}

export const doGetPlanStartInfo = ({ planID, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetPlanStartInfo',
			data: { planID },
		},
		...rest
	})
}

export const doSavePlanStartInfo = ({ planID, changeValues, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'SavePlanStartInfo',
			data: { planID, changeValues },
		},
		...rest
	})
}

export const doGetDataEntryList = ({ row, query, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetDataEntryList',
			data: { row, query },
		},
		...rest
	})
}

export const doGetDataReviewList = ({ row, query, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetDataReviewList',
			data: { row, query },
		},
		...rest
	})
}

export const doGetSample = ({ sampleID, itype, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetSample',
			data: { sampleID, itype },
		},
		...rest
	})
}

export const doGetInspectionInfo = ({ sampleInspectionID, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetInspectionInfo',
			data: { sampleInspectionID },
		},
		...rest
	})
}

export const doSaveInspectionInfo = ({ sampleInspectionID, changeValues, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'SaveInspectionInfo',
			data: { sampleInspectionID, changeValues },
		},
		...rest
	})
}

export const doSubmitInspectionInfo = ({ sampleInspectionID, action, comment, changeValues, needInstrument, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'SubmitInspectionInfo',
			data: { sampleInspectionID, action, comment, changeValues, needInstrument },
		},
		...rest
	})
}

export const doGetInspectionDeviceInfo = ({ sampleInspectionID, inspectionDeviceID, number, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetInspectionDeviceInfo',
			data: { sampleInspectionID, inspectionDeviceID, number },
		},
		...rest
	})
}

export const doSaveInspectionDeviceInfo = ({ sampleInspectionID, inspectionDeviceID, changeValues, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'SaveInspectionDeviceInfo',
			data: { sampleInspectionID, inspectionDeviceID, changeValues },
		},
		...rest
	})
}

export const doDelInspectionDeviceInfo = ({ sampleInspectionID, inspectionDeviceID, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'DelInspectionDeviceInfo',
			data: { sampleInspectionID, inspectionDeviceID },
		},
		...rest
	})
}

export const doGetDailyTaskTobeProcessedList = ({ row, query, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetDailyTaskTobeProcessedList',
			data: { row, query },
		},
		...rest
	})
}

export const doGetDailyTaskToBeConfirmedList = ({ row, query, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetDailyTaskToBeConfirmedList',
			data: { row, query },
		},
		...rest
	})
}

export const doGetDailyTaskHandleOfTheList = ({ row, query, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetDailyTaskHandleOfTheList',
			data: { row, query },
		},
		...rest
	})
}

export const doGetDailyTaskHasBeenCompletedList = ({ row, query, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetDailyTaskHasBeenCompletedList',
			data: { row, query },
		},
		...rest
	})
}

export const doGetDailyTask = ({ dailyTaskID, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetDailyTask',
			data: { dailyTaskID },
		},
		...rest
	})
}

export const doSaveDailyTask = ({ dailyTaskID, changeValues, testResult, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'SaveDailyTask',
			data: { dailyTaskID, changeValues, testResult },
		},
		...rest
	})
}

export const doDelDailyTask = ({ dailyTaskID, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'DelDailyTask',
			data: { dailyTaskID },
		},
		...rest
	})
}

export const doGetDailyTaskInfo = ({ dailyTaskID, itype, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetDailyTaskInfo',
			data: { dailyTaskID, itype },
		},
		...rest
	})
}

export const doSubmitDailyTask = ({ dailyTaskID, itype, changeValues, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'SubmitDailyTask',
			data: { dailyTaskID, itype, changeValues },
		},
		...rest
	})
}

//数据引用审批
export const doGetQuoteDataApprovalList = ({ row, query, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetQuoteDataApprovalList',
			data: { row, query },
		},
		...rest
	})
}

export const doGetQuoteData = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetQuoteData',
			data: { id },
		},
		...rest
	})
}

export const doQuoteDataFlow = ({ id, action, memo, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'QuoteDataFlow',
			data: { id, action, memo },
		},
		...rest
	})
}

//排工审核
export const doGetSchedulingAuditList = ({ row, query, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetSchedulingAuditList',
			data: { row, query },
		},
		...rest
	})
}

export const doGetSchedulingData = ({ id, ...rest } = {}) => {
	return postEvent({
		event: 'PostLims',
		data: {
			event: 'GetSchedulingData',
			data: { id },
		},
		...rest
	})
}